module.exports = __webpack_public_path__ + "media/images/country_flags/gs-0a2e168fa3e49261fa588372ec7b6964.png";